/**
 * The small amount of formatting admin-written copy is allowed to carry.
 *
 * WHY NOT MARKDOWN, AND WHY NOT HTML. HTML typed into a settings box and rendered would be an
 * injection hole in a field several people can edit; a Markdown library is a dependency and a
 * surface area for copy that needs two things. What people actually ask for is a word in bold and
 * a line that starts on its own line — so that is what this does, and nothing else. Anything it
 * does not recognise is shown exactly as typed rather than swallowed.
 *
 * WHAT IS SUPPORTED:
 *   **bold**        a bold run
 *   a newline       a line break
 *   a blank line    a gap between paragraphs
 *
 * IT RENDERS INLINE CONTENT ONLY — bold runs and <br> — so it is safe inside a <p>, a <li>, a
 * table cell or a heading without producing invalid nesting. The caller decides the block element.
 *
 * This was written inline in three different components before it was extracted. If a fourth
 * place needs formatted copy, use this rather than writing a fourth.
 */

/** One line's bold runs. `**` with nothing between it is left alone rather than eaten. */
function boldRuns(line, keyPrefix) {
  return String(line)
    .split(/(\*\*[^*]+\*\*)/g)
    .filter((part) => part !== '')
    .map((part, i) =>
      part.startsWith('**') && part.endsWith('**') ? (
        <strong key={`${keyPrefix}-${i}`} className="font-semibold">
          {part.slice(2, -2)}
        </strong>
      ) : (
        <span key={`${keyPrefix}-${i}`}>{part}</span>
      )
    );
}

export default function RichText({ children }) {
  const text = children === undefined || children === null ? '' : String(children);
  if (!text) return null;

  const lines = text.split('\n');
  return (
    <>
      {lines.map((line, i) => (
        <span key={i}>
          {/*
            A blank line is a gap, not an empty row: rendering it as a <br> pair would double the
            spacing every time somebody pressed Enter twice, which is how most people type a new
            paragraph.
          */}
          {i > 0 && <br />}
          {line.trim() === '' ? null : boldRuns(line, i)}
        </span>
      ))}
    </>
  );
}

export { boldRuns };
